/**
 * Collection E-Learning Courses Carousel
 * Uses shared initScrollSnapCarousel from utils.js
 */

(function () {
  "use strict";

  function init() {
    initScrollSnapCarousel({
      sectionSelector: ".collection-e-learning-courses",
      containerSelector: ".collection-e-learning-courses__products-container",
      itemsContainerSelector: "#collection-e-learning-courses-products-{sectionId}",
      itemSelector: ".collection-e-learning-courses__product-item",
      paginationSelector: "#collection-e-learning-courses-pagination-{sectionId}",
      dotClass: "collection-e-learning-courses__pagination-dot",
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
